"use client"

import { Suspense } from "react"

import { InboundLabelLink } from "@/components/labels/inbound-label-link"
import { LabelEditor } from "@/components/labels/label-editor"

export default function LabelsPage() {
  return (
    <>
      <Suspense fallback={null}>
        <InboundLabelLink />
      </Suspense>
      <LabelEditor />
    </>
  )
}
